export default __webpack_public_path__ + "static/media/googleCloud.adfdf6e4.png";